import "@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css";
import MapboxDraw from "@mapbox/mapbox-gl-draw";

// moznost pridat dalsiu ikonku do draw
import ExtendDrawBar from "./extendDrawBar/extendDrawBar";

// nacitam si custom styly pre draw
import drawStyles from "./drawStyles";

import DirectSelectMode from "./extendDrawEvents/direct_select";
import DrawLineStringMode from "./extendDrawEvents/draw_line_string";
import DrawPolygonMode from "./extendDrawEvents/draw_polygon";
import DrawRectangleMode from "./extendDrawEvents/draw_rectangle";
import DrawPointMode from "./extendDrawEvents/draw_point";

import { hooksStore } from "../../../../stores/hooks.store";
import { tempStore } from "../../../../stores/temp.store";

import set from "set-value";
import { get as get_store } from "svelte/store";

// vytvaram custom mod pre draw - nakreslenie obdlznika
const modes = MapboxDraw.modes;
modes.draw_rectangle = DrawRectangleMode;
modes.direct_select = DirectSelectMode;
modes.draw_line_string = DrawLineStringMode;
modes.draw_polygon = DrawPolygonMode;
modes.draw_point = DrawPointMode;
modes.custom_select = MapboxDraw.modes.direct_select;
modes.custom_select.clickInactive = () => {};

hooksStore.addAction("editSourceDraw", "Controls.svelte", editSourceDraw);

// nastavenia pre draw
const Draw = new MapboxDraw({
  displayControlsDefault: false,
  controls: {
    point: true,
    line_string: true,
    polygon: true,
    trash: true,
  },
  modes: modes,
  styles: drawStyles,
  userProperties: true,
});

// custom pridanie dalsieho buttonu do draw
const mapboxDraw = new ExtendDrawBar({
  draw: Draw,
  buttons: [
    {
      on: "click",
      action: changeModeToDrawRetangle,
      classes: ["mapbox-gl-draw_polygon2"],
    },
    {
      on: "click",
      action: cancel,
      classes: ["mapbox-gl-draw_cancel"],
      childNodes: -1,
      title: "Zrušiť kreslenie",
    },
  ],
});

function editSourceDraw(sourceData, poznamka_id) {
  const kresleniaIds = [];
  for (let i = 0; i < sourceData.features.length; i++) {
    kresleniaIds.push(Draw.add(sourceData.features[i])[0]);
  }

  let store = get_store(tempStore);
  const aktivneKreslenia = Draw.getAll();
  set(store, "kreslenia", aktivneKreslenia);
  set(store, "kresleniaKPoznamke", { [poznamka_id]: kresleniaIds });
  tempStore.set(store);
}

hooksStore.addAction(
  "zmazKonkretneKreslenie",
  "index.js",
  zmazKonkretneKreslenie
);
function zmazKonkretneKreslenie(id) {
  Draw.delete(id);
}

function cancel() {
  hooksStore.doAction("confirmDialog", {
    texts: {
      title: "Všetky aktívne kreslenia sa zmažú.",
      text: "Chcete pokračovať?",
      confirm: "Áno",
      cancel: "Zrušiť",
    },
    callback: () => {
      hooksStore.doAction("zmazatVsetkyPopupOkna");
      Draw.deleteAll();
    },
  });
  /* if (confirm("Všetky aktívne kreslenia sa zmažú. Chcete pokračovať?")) {
    hooksStore.doAction("zmazatVsetkyPopupOkna");
    Draw.deleteAll();
  } */
}

// ked kliknem na custom kreslenie obdlznika, musim zmenit funkcionalitu draw
function changeModeToDrawRetangle() {
  Draw.changeMode("draw_rectangle");
}

export { Draw, mapboxDraw };
